module.exports = __webpack_public_path__ + "static/media/main.17b22d23.png";